// Angular
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';

// Pages
import {CoreModule} from '../../core/core.module';

import {SharedModule} from '../component/shared.module';
import {PortletModule} from '../partials/content/general/portlet/portlet.module';
import {ProductComponent} from './product/product.component';
import {NgbTabsetModule, NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {HomeModule} from './home/home.module';
import {ActivityModule} from './activity/activity.module';
import {AdminModule} from './admin/admin.module';
import {PopupModule} from '../component/popup/popup.module';
import { UsersComponent } from './users/users.component';
import {TranslateModule} from '@ngx-translate/core';
import { AnalysisPage } from './analysis/analysis.page';
import {PaymentComponent} from './payment/payment.component';
import { CardInfoComponent } from './payment/card-info/card-info.component';

@NgModule({
  declarations: [
    ProductComponent,
    UsersComponent,
    AnalysisPage,
    PaymentComponent,
    CardInfoComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    SharedModule,
    PortletModule,
    NgbTimepickerModule,
    RouterModule,
    NgbTabsetModule,
    ReactiveFormsModule,
    HomeModule,
    ActivityModule,
    AdminModule,
    PopupModule,
    TranslateModule
  ],
  providers: []
})
export class PagesModule {
}
